import { Button } from '@wot/components';
import TutorCard from './TutorCard';
import Slider from './Slider';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  button?: boolean;
  tutors: any;
  btnLink?: string;
}

export default function TutorDiv({ title, button, tutors, btnLink }: Props) {
  return (
    <div>
      <div className="mx-auto">
        <div className="flex flex-col w-full">
          <div className="lg:hidden flex items-baseline justify-between mt-5">
            <h1 className="lg:text-3xl text-xl font-medium">{title}</h1>
            {button && <span className="text-secondary underline text-lg font-medium">View All</span>}
          </div>
          <div className="bg-white rounded-lg p-5 my-10 max-w-full w-full">
            <div className="lg:flex lg:justify-center lg:m-5 hidden">
              <h1 className="text-3xl font-medium">{title}</h1>
            </div>
            {tutors.length > 0 ? (
              <>
                <div className="lg:grid lg:grid-cols-4 lg:my-2 lgz:w-full hidden">
                  {tutors && tutors.map((item: any, index: any) => <TutorCard item={item} key={index} />)}
                </div>
                <div className="lg:hidden">
                  <Slider>
                    {tutors && tutors.map((item: any, index: any) => <TutorCard item={item} key={index} />)}
                  </Slider>
                </div>
                {button && btnLink && (
                  <div className="lg:flex lg:w-full lg:max-w-[100px] lg:m-auto hidden">
                    <Link to={btnLink}>
                      <Button text="View all" size="lg" />
                    </Link>
                  </div>
                )}
              </>
            ) : (
              <div>Oops no tutors found!</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
